<template>
  <v-app>
    <v-overlay :value="overlay" class="12">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <router-view v-if="!overlay"></router-view>
  </v-app>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import store from './store'
import MainLayout from "@/components/layouts/MainLayout";

export default {
  name: 'App',
  components: {
    MainLayout
  },
  data() {
    return {
      overlay: true,
      isSignedUserInterval: false
    }
  },
  methods: {
    checkPeriodically() {
      // eslint-disable-next-line no-underscore-dangle
      if (this.$root._route.path.includes('login')) {
        return;
      }

      this.isSignedUserInterval = setInterval(async () => {
        const token = this.$cookies.get('accessToken');
        await store.dispatch('user/VerifyTokenEmailSave', token);
        if (!token || !store.state.user.verifyTokenEmail) {
          // eslint-disable-next-line no-alert
          localStorage.setItem('redirectUrl', this.$route.fullPath);
          alert('You have been signed out. Please login again');
          clearInterval(this.isSignedUserInterval);
          await this.$router.push('/login');
        }
      }, 60000);
    },
    checkPermissions() {
      if (this.user[0]) {
        const path = this.$route.path.split('/');
        if (
            (path[1] === 'analytics' && !this.user[0].can('see_analytics_section'))
            || (path[1] === 'affiliates' && !this.user[0].can('see_affiliates_section'))
            || (path[1] === 'advertisers' && !this.user[0].can('see_advertisers_section'))
            || (path[1] === 'finance' && !this.user[0].can('see_finance_section'))
        ) {
          this.$router.push('/403');
        }
      }
    },
  },
  async created() {
    this.overlay = true;
    try {
      const token = this.$cookies.get('accessToken');

      if (token) {
        await store.dispatch('user/VerifyTokenEmailSave', token);

        if (!this.verifyTokenEmail) {
          this.$cookies.remove('accessToken');
          const checkPatch = this.$root._route.path.includes('successLogin') || this.$root._route.path.includes('errorLogin');
          if (!checkPatch) {
            localStorage.setItem('redirectUrl', this.$route.fullPath);
          }
          await this.$router.push('/login');
        } else {
          await store.dispatch('user/saveUserStore', this.verifyTokenEmail);
          // get data that can be used across all components like list of managers
          this.checkPermissions()
        }
      } else {
        // eslint-disable-next-line no-underscore-dangle
        const checkPatch = this.$root._route.path.includes('successLogin') || this.$root._route.path.includes('errorLogin');

        if (!checkPatch) {
          if (this.$route.path !== '/login') {
            localStorage.setItem('redirectUrl', this.$route.fullPath);
            this.$router.push('/login')
          }
        }
      }
    } catch (err) {
      console.log(err);
      await this.$router.push('/login');
    } finally {
      this.overlay = false;
    }

    this.checkPeriodically();
  },
  destroyed() {
    clearInterval(this.isSignedUserInterval);
  },
  computed: {
    ...mapState('user', ['user', 'verifyTokenEmail']),
    ...mapState('managers', ['affiliateManagers']),
  },
}
</script>
